import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router";

import { forceQuillRerender } from "../store/actions/admin/create-event";
import { IAdminSessionParams } from "../types/working-model";
import usePrevious from "./use-previous";

const useRerenderQuillOnLanguageChange = () => {
	const params = useParams<IAdminSessionParams>();

	const language = params?.language;

	const previousLanguage = usePrevious(language);

	const dispatch = useDispatch();

	useEffect(() => {
		if (previousLanguage && previousLanguage !== language) {
			dispatch(forceQuillRerender(true));
			setTimeout(() => {
				dispatch(forceQuillRerender(false));
			}, 0);
		}
	}, [dispatch, language, previousLanguage]);
};

export default useRerenderQuillOnLanguageChange;
